export default "__VITE_ASSET__d6230830__"